import { render, staticRenderFns } from "./Project1Zh.vue?vue&type=template&id=3bd14e32&scoped=true&"
import script from "./Project1Zh.vue?vue&type=script&lang=js&"
export * from "./Project1Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project1Zh.vue?vue&type=style&index=0&id=3bd14e32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd14e32",
  null
  
)

export default component.exports